// Action Types
export const GET_PUBLICATION_SCHEDULE_REQUEST = "GET_PUBLICATION_SCHEDULE_REQUEST";
export const GET_PUBLICATION_SCHEDULE_SUCCESS = "GET_PUBLICATION_SCHEDULE_SUCCESS";
export const GET_PUBLICATION_SCHEDULE_FAILURE = "GET_PUBLICATION_SCHEDULE_FAILURE";

// Action Creators
export const getPublicationScheduleRequest = (payload) => ({
  type: GET_PUBLICATION_SCHEDULE_REQUEST,
  payload,
});

export const getPublicationScheduleSuccess = (data) => ({
  type: GET_PUBLICATION_SCHEDULE_SUCCESS,
  payload: data,
});

export const getPublicationScheduleFailure = (error) => ({
  type: GET_PUBLICATION_SCHEDULE_FAILURE,
  payload: error,
});
